import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TreatmentWizardSettingsStore } from './treatment-wizard-settings.store';
import { FamilyWizardModel } from '../../models/family-wizard.model';
import { TreatmentWizardSettingsQuery } from './treatment-wizard-settings.query';
import { Observable } from 'rxjs';
import { familyWizardFactory } from '../appointment-wizard-settings/appointment-wizard-settings.store';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { UserQuery } from '../user/user.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { ProductWizardService } from '../product-wizard/product-wizard.service';
import { PaymethodWizardService } from '../paymethod-wizard/paymethod-wizard.service';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class TreatmentWizardSettingsService {
    constructor(
        private treatmentWizardSettingsStore: TreatmentWizardSettingsStore,
        private treatmentWizardSettingsQuery: TreatmentWizardSettingsQuery,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private userQuery: UserQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private productWizardService: ProductWizardService,
        private paymethodWizardService: PaymethodWizardService,
        private apiService: ApiService
    ) {}

    /*-----------*/
    /** UPDATES */
    /*----------*/
    updateFamilies(newFamilies: FamilyWizardModel[]) {
        this.treatmentWizardSettingsStore.update({ families: newFamilies });
    }

    updateCancelShippingUserChecked(newCancelShippingUserChecked) {
        this.treatmentWizardSettingsStore.update({
            cancelShippingUserChecked: newCancelShippingUserChecked,
        });
    }

    updateConfirmShippingUserChecked(newConfirmShippingUserChecked) {
        this.treatmentWizardSettingsStore.update({
            confirmShippingUserChecked: newConfirmShippingUserChecked,
        });
    }

    updateShippingAddress(newShippingAddress) {
        this.treatmentWizardSettingsStore.update({
            shippingAddress: newShippingAddress,
        });
    }

    /** TODO: He intentado usar la función de akita arrayAdd pero no me funciona, uso este método para añadir elementos a un array */
    pushStepStack(step: number) {
        const currentStepStack = this.treatmentWizardSettingsQuery.getValue()
            ?.stepStack;
        const cloneStepStack = [...currentStepStack];
        cloneStepStack.push(step);
        this.treatmentWizardSettingsStore.update({
            stepStack: cloneStepStack,
        });
    }

    /** TODO: He intentado usar la función de akita arrayAdd pero no me funciona, uso este método para añadir elementos a un array */
    popStepStack() {
        const currentStepStack = this.treatmentWizardSettingsQuery.getValue()
            ?.stepStack;
        const cloneStepStack = [...currentStepStack];
        cloneStepStack.pop();
        this.treatmentWizardSettingsStore.update({
            stepStack: cloneStepStack,
        });
    }

    clearStepStack() {
        this.treatmentWizardSettingsStore.update({
            stepStack: [],
        });
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/
    /**
     * Llamada api para obtener la configuración del asistente de compras
     * TODO: Ver por qué se pasan muchos parámetros a undefined
     */
    private getTreatmentWizardSettingsApi(
        systemKey: string,
        tokenId: string,
        clinicId: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClientToken', tokenId);
        params = params.append('ClinicID', clinicId);
        params = params.append('Products', undefined);
        params = params.append('PayMethodID', undefined);
        params = params.append('Url', undefined);
        params = params.append('Cmd', 'c2001');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/
    /** Este servicio llama a la API para recoger los datos y la configuración inicial del asistente de pedir cita y rellena el store */
    async getTreatmentWizardSettings() {
        const treatmentWizardSettingsData = await this.getTreatmentWizardSettingsApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            this.clinicDetailQuery.id
        ).toPromise();

        this.treatmentWizardSettingsStore.update({
            shippingEnabled:
                treatmentWizardSettingsData?.Shipping?.ShippingEnabled,
            shippingAddress:
                treatmentWizardSettingsData?.Shipping?.ShippingAddress,
        });
        this.productWizardService.setProductsWizardByApi(
            treatmentWizardSettingsData?.Products
        );

        this.paymethodWizardService.setPaymethodsWizardByApi(
            treatmentWizardSettingsData?.PayMethods
        );

        this.setFamiliesWizardByApi(treatmentWizardSettingsData?.Families);
    }

    /**
     * Crea las familias a partir de los datos de la API y los carga en el Store
     */
    setFamiliesWizardByApi(families) {
        if (families?.length > 0) {
            const familiesWizardEntities = [];
            families.forEach((familyWizard) => {
                familiesWizardEntities.push(familyWizardFactory(familyWizard));
            });

            this.updateFamilies(familiesWizardEntities);
        }
    }

    resetStore() {
        this.treatmentWizardSettingsStore.reset();
    }
}
